import serialize from "json-form-data";

const api_url = "/index.php";

function getQueryString(queryParams) {
    return Object.entries(queryParams)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
}

export default {
    namespaced: true,
    actions: {
        async loadList(ctx, params) {
            const queryParams = {
                auth_key: ctx.rootState.authToken,
                r: "api/iiko-access-settings/index",
                page: params.page
            };

            if (params.query) {
                queryParams.search = params.query;
            }

            if (params.sortBy) {
                queryParams.sort = `${params.desc ? "-" : ""}${params.sortBy}`;
            }

            const query = getQueryString(queryParams);

            const res = await fetch(`${api_url}/?${query}`);
            const json = await res.json();
            return json;
        },

        async createAccess(ctx, params) {
            const query = getQueryString({
                auth_key: ctx.rootState.authToken,
                r: "api/iiko-access-settings/create"
            });

            const postParams = {
                name: params.terminalName,
                terminal_id: params.terminalId,
                host: params.host,
                login: params.login,
                newPassword: params.password
            };

            const body = serialize(postParams);

            const res = await fetch(`${api_url}/?${query}`, {
                method: "POST",
                body
            });
            const json = await res.json();
            return json;
        },

        async updateAccess(ctx, params) {
            const query = getQueryString({
                auth_key: ctx.rootState.authToken,
                r: "api/iiko-access-settings/update",
                id: params.id
            });

            const postParams = {
                name: params.terminalName,
                terminal_id: params.terminalId,
                host: params.host,
                login: params.login
            };

            if (params.password) {
                postParams.newPassword = params.password;
            }

            const body = serialize(postParams);

            const res = await fetch(`${api_url}/?${query}`, {
                method: "PUT",
                body
            });
            const json = await res.json();
            return json;
        },

        async removeAccess(ctx, params) {
            const query = getQueryString({
                auth_key: ctx.rootState.authToken,
                r: "api/iiko-access-settings/delete",
                id: params.id
            });

            const res = await fetch(`${api_url}/?${query}`, {
                method: "DELETE"
            });
            const json = await res.json();
            return json;
        }
    }
};
